import { render, staticRenderFns } from "./InDmChatArea.vue?vue&type=template&id=87f8e85c&scoped=true"
import script from "./InDmChatArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./InDmChatArea.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InDmChatArea.vue?vue&type=style&index=0&id=87f8e85c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f8e85c",
  null
  
)

export default component.exports